const stickyToolbarCSS = ({ theme }) => ({
  background: theme.white,
  position: 'sticky',
  top: 0,
  zIndex: theme['z-base'],
})

export default stickyToolbarCSS
